const monthNumberToNameObject = {
    '01': 'Janeiro',
    '02': 'Fevereiro',
    '03': 'Março',
    '04': 'Abril',
    '05': 'Maio',
    '06': 'Junho',
    '07': 'Julho',
    '08': 'Agosto',
    '09': 'Setembro',
    '10': 'Outubro',
    '11': 'Novembro',
    '12': 'Dezembro',
}

const monthNameToNumberObject = {
    'jan': '01',
    'fev': '02',
    'mar': '03',
    'abr': '04',
    'mai': '05',
    'jun': '06',
    'jul': '07',
    'ago': '08',
    'set': '09',
    'out': '10',
    'nov': '11',
    'dez': '12',
    'feb': '02',
    'apr': '04',
    'may': '05',
    'aug': '08',
    'sep': '09',
    'oct': '10',
    'dec': '12'
}

const detectDataLanguage = (date) => {
    const ptRe = new RegExp("[0-9]{1,2}\\s[d-e]{2}\\s[a-z]{3}\\s[d-e]{2}\\s[0-9]{4}")
    const ptEn = new RegExp("[a-zA-Z]{3}\\s[0-9]{1,2}\\W\\s[0-9]{4}")
    const isPortuguese = ptRe.test(date);
    const isEnglish = ptEn.test(date)
    return isPortuguese ? 'portuguese'
           : isEnglish ? 'english'
           : null
} 

const getDateValues = (date, language) => {
    let day, month, year;
    if(language === 'portuguese') {
        // date example: 4 de dez de 2023
        const splited_date = date.replaceAll(new RegExp("\\b[d-e]{2}\\b", "gm"), "").split(" ").filter(item => item)
        day = splited_date[0]
        month = splited_date[1]
        year = splited_date[2]
    } else {
        const splited_date = date.replaceAll(",", "").split(" ").filter(item => item)
        day = splited_date[1]
        month = splited_date[0]
        year = splited_date[2]
    }

    return [
        day,
        month.toLowerCase(), 
        year
    ]
}

const formatDate = (date) => {
    return new Date(date).toLocaleDateString()
}

const formatHour = (date) => {
    return new Date(date).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })
}

const formatCellPhone = (num_telefone) => {
    if (!num_telefone || !/^\d{10,}$/.test(num_telefone.replace(/\D/g, ''))) {
        return num_telefone
    }
    const removeDDI = num_telefone.slice(2)
    const ddd = removeDDI.slice(0, 2)
    const onlyNumber = removeDDI.slice(2)
    return `(${ddd}) ${onlyNumber}`
}

export { monthNumberToNameObject, monthNameToNumberObject, detectDataLanguage, getDateValues, formatDate, formatHour, formatCellPhone }